import { useQuery } from '@tanstack/react-query';

import { getBoostedCatalog } from '~/services/BoostedCatalogService';

import { boostedCatalogQueryKeys } from './boostedCatalogQueryKeys';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export function useGetBoostedCatalog() {
  const query = useQuery({
    queryKey: boostedCatalogQueryKeys.all,
    queryFn: async ({ signal }) => getBoostedCatalog({ signal }),
    staleTime: FIVE_MINUTES_MS,
    retry: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
  };
}
